module.exports = __webpack_public_path__ + "img/sbl0014.5de875a7.png";